import React, { useMemo } from 'react';
import { Col, Form, Row, Typography, Checkbox, Upload } from 'antd';
import { useTranslation } from 'react-i18next';
import { InboxOutlined } from '@ant-design/icons';
import FormHelper from 'helpers/FormHelper';
import { Descriptions } from 'antd';

const FileSection = ({ file }) => {
  const { t } = useTranslation();
  const fileList = useMemo(() => {
    const l = [];
    if (file) {
      l.push({
        uid: file.id,
        name: file.name,
        status: 'done',
        url: file.url,
      });
    }

    return l;
  }, [file]);

  return (
    <Row gutter={24}>
      <Col span={6}>
        <Typography.Title level={3}>{t('File')}</Typography.Title>
      </Col>
      <Col span={9}>
        <Form.Item
          // label={t('Village')}
          name='file'
        >
          <Upload.Dragger
            multiple={false}
            name='file'
            beforeUpload={FormHelper.beforeUpload}
            defaultFileList={fileList}
          >
            <p className='ant-upload-drag-icon'>
              <InboxOutlined />
            </p>
            <p className='ant-upload-text'>
              {t('Click or drag file to this area to upload1')} "JPG", "PNG", "GIF", "PDF", "DOC", "DOCX", "XLS", "XLSX", "PPT","MP4", "MP3", "AVI" {t('Click or drag file to this area to upload2')}
            </p>
          </Upload.Dragger>
        </Form.Item>
        <Descriptions column={1} bordered>
          <Descriptions.Item label={`${t('Formati accettati')}:`}>
            JPG PNG GIF PDF DOC DOCX XLS XLSX PPT MP4 MP3 AVI
          </Descriptions.Item>
          <Descriptions.Item label={`${t('Dimensione massima')}:`}>
            500MB
          </Descriptions.Item>
        </Descriptions>
      </Col>
      <Col offset={6} span={18}>
        <Form.Item
          name='telegram' // TODO: ask back-end about this field
          valuePropName='checked'
        >
          <Checkbox value={'Pubblicare su Telegram?'}>
            {t('Pubblicare su Telegram?')}
          </Checkbox>
        </Form.Item>
      </Col>
    </Row>
  );
};

export default React.memo(FileSection);
